import React, { useState, useEffect, useRef } from 'react';
import "./ChatProfile.css";
import { useMessengerContext } from '../../hooks/useMessengerContext';
import SwipeableViews from 'react-swipeable-views-react-18-fix';
import { useAuthContext } from '../../hooks/useAuthContext';
import { useFetchProfile } from '../../hooks/useGetProfile';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { auth } from "../../Firebase";

const ChatProfile = ({ onBackToChatBoxForCSS }) => {
  const { state } = useMessengerContext();
  const { otherUserDisplay, community, currentConversation } = state;
  const { user } = useAuthContext();
  const [token, setToken] = useState(null);

    useEffect(() => {
    const fetchToken = async () => {
      if (auth.currentUser) {
        try {
          const idToken = await auth.currentUser.getIdToken();
          setToken(idToken);
        } catch (error) {
          console.error('[chatProfile.js] Error getting token:', error);
          // Set a fallback token or handle error appropriately
          setToken('fallback');
        }
      } else {
        // If no current user, wait a bit and try again
        const retryTimer = setTimeout(() => {
          if (auth.currentUser) {
            auth.currentUser.getIdToken().then(setToken).catch(err => {
              console.error('[chatProfile.js] Retry token error:', err);
              setToken('fallback');
            });
          }
        }, 1000);
        return () => clearTimeout(retryTimer);
      }
    };
    fetchToken();
  }, [user]);


  // Track previous values to detect transitions
  const prevUserIdRef = useRef();
  const prevCommunityIdRef = useRef();

  // Check if this is a community bot conversation (has communityId but no userId in otherUserDisplay)
  const isCommunityBotProfile = !otherUserDisplay?.userId && otherUserDisplay?.communityId;

  // 1️This hook ALWAYS runs on every render - but only for regular user profiles
  const { profile, isLoading, } = useFetchProfile(
    isCommunityBotProfile ? null : otherUserDisplay?.userId, // Don't fetch for community bots
    otherUserDisplay?.communityId,
    token
  );

  console.log('otherUserDisplayff',otherUserDisplay)

  console.log("[chatProfile.js useFetchProfile called and user:", user)
  
  // 2️This state is always initialized
  const [currentIndex, setCurrentIndex] = useState(0);

  // 3️This effect runs AFTER render when IDs change
  useEffect(() => {
    console.log('[chatProfile.js] otherUserDisplay transition:', {
      previous: {
        userId: prevUserIdRef.current,
        communityId: prevCommunityIdRef.current
      },
      current: {
        userId: otherUserDisplay?.userId,
        communityId: otherUserDisplay?.communityId
      }
    });

    // Update refs after logging
    prevUserIdRef.current = otherUserDisplay?.userId;
    prevCommunityIdRef.current = otherUserDisplay?.communityId;
  }, [otherUserDisplay?.userId, otherUserDisplay?.communityId]);

  // 🔄 Rerenders happen because:
  // - useFetchProfile's internal state changes (profile/isLoading updates)
  // - Parent component updates context (state changes)
  // - NOT because of the useEffect above
  
  // For community bot profiles, we don't need a token or regular user profile fetch
  if (isCommunityBotProfile) {
    console.log('[chatProfile.js] Community bot profile detected', {
      communityId: otherUserDisplay?.communityId,
      hasOtherUserDisplay: !!otherUserDisplay,
      otherUserDisplayKeys: otherUserDisplay ? Object.keys(otherUserDisplay) : 'none'
    });
    if (!otherUserDisplay?.communityId) {
      console.log('[chatProfile.js] ❌ Waiting for community bot data - missing communityId');
      return <div>Loading profile details...</div>;
    }
    console.log('[chatProfile.js] ✅ Community bot profile ready to render');
  } else {
    // For regular user profiles, we need all the data
    console.log('[chatProfile.js] Regular user profile detected', {
      hasCommunityId: !!otherUserDisplay?.communityId,
      hasUserId: !!otherUserDisplay?.userId,
      hasToken: !!token
    });
    if (!otherUserDisplay?.communityId || !otherUserDisplay?.userId || !token) {
      console.log('[chatProfile.js] ❌ Waiting for user profile data');
      return <div>Loading profile details...</div>;
    }
    console.log('[chatProfile.js] ✅ User profile ready to render');
  }
  // Structured logging for debugging
  console.log('[chatProfile.js] Context values:', {
    otherUserDisplay,
    community: community?.title,
    currentConversationId: currentConversation?._id,
    userLoggedIn: !!user
  });
  console.log('[chatProfile.js] useFetchProfile called with:', {
    userId: otherUserDisplay?.userId,
    communityId: otherUserDisplay?.communityId
  });
  console.log('[chatProfile.js] Profile fetch results:', {
    isLoading,
    profileFound: !!profile,
    userId: otherUserDisplay?.userId,
    communityId: otherUserDisplay?.communityId
  });

  // Determine if this is a community chat (either from conversation members or from otherUserDisplay structure)
  const isCommunityChat = currentConversation?.members?.includes(currentConversation?.communityId) || isCommunityBotProfile;
  console.log('[chatProfile.js] Is community chat:', isCommunityChat, 'isCommunityBotProfile:', isCommunityBotProfile);

  // Loading state for profile fetch (only for regular user conversations)
  if (!isCommunityChat && (isLoading || !profile)) {
    console.log('[chatProfile.js] Showing loader because:', {
      isLoading,
      hasProfile: !!profile,
      missingUserId: !otherUserDisplay?.userId,
      missingCommunityId: !otherUserDisplay?.communityId
    });
    return <div>Loading profile...</div>;
  }

  // For community chat via old method, ensure community data is available
  if (isCommunityChat && !isCommunityBotProfile && !community) {
    console.log('[chatProfile.js] Showing loader because community data missing');
    return <div>Loading profile...</div>;
  }

  console.log('[chatProfile.js] profile object is',profile);

  console.log('[chatProfile.js] Rendering full profile component');
  return (
    <div className="profile-container">
      <div className="icon-container">
        <div
          onClick={onBackToChatBoxForCSS}
          className="chatbox-header-back-btn hide-on-desktop"
        >
          ←|
        </div>
      </div>

      {isCommunityChat ? (
        <div className="community-profile-section">
          <SwipeableViews
            enableMouseEvents
            index={currentIndex}
            onChangeIndex={setCurrentIndex}
          >
            {(isCommunityBotProfile ? otherUserDisplay?.pics : community?.pics)?.map((pic, index) => {
              console.log(`[chatProfile.js] Rendering community image ${index}`);
              return (
                <div key={index} className="profile-image-container">
                  <img src={pic} alt={`Community ${index + 1}`} className="profile-image" />
                  <div className="navigation-controls">
                    <div
                      onClick={() => setCurrentIndex(Math.max(0, currentIndex - 1))}
                      className="icon arrow-left"
                    >
                      <FontAwesomeIcon icon={faArrowLeft} />
                    </div>
                    <div
                      onClick={() => setCurrentIndex(Math.min((isCommunityBotProfile ? otherUserDisplay?.pics : community?.pics)?.length - 1, currentIndex + 1))}
                      className="icon arrow-right"
                    >
                      <FontAwesomeIcon icon={faArrowRight} />
                    </div>
                  </div>
                </div>
              );
            })}
          </SwipeableViews>
          <div className="community-info">
            <h2>{isCommunityBotProfile ? otherUserDisplay?.title : community?.title}</h2>
            <p id="community-bio">
              Hi I'm your {isCommunityBotProfile ? otherUserDisplay?.title : community?.title} bot. I'll help find and introduce you to people in your community.
            </p>
          </div>
        </div>
      ) : (
        <div className="user-profile-section">
          <SwipeableViews
            enableMouseEvents
            index={currentIndex}
            onChangeIndex={setCurrentIndex}
          >
            {profile?.pics?.map((pic, index) => {
              console.log(`[chatProfile.js] Rendering user image ${index}`);
              return (
                <div key={index} className="profile-image-container">
                  <img
                    src={encodeURI(pic)}
                    alt={`Profile ${index + 1}`}
                    className="profile-image"
                  />
                  <div className="navigation-controls">
                    <div
                      onClick={() => setCurrentIndex(Math.max(0, currentIndex - 1))}
                      className="icon arrow-left"
                    >
                      <FontAwesomeIcon icon={faArrowLeft} />
                    </div>
                    <div
                      onClick={() => setCurrentIndex(Math.min(profile.pics.length - 1, currentIndex + 1))}
                      className="icon arrow-right"
                    >
                      <FontAwesomeIcon icon={faArrowRight} />
                    </div>
                  </div>
                </div>
              );
            })}
          </SwipeableViews>
          <div className="user-details">
            <h2>{profile?.name}, {profile?.age}</h2>
            {profile?.communityName && (
              <h3 className="community-bio-header">{profile?.name}'s {profile.communityName} bio:</h3>
            )}
            <p id="user-bio">{profile?.bio}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatProfile;


//2025
// 
// // import React, { useState, useEffect } from 'react';
// import "./ChatProfile.css";
// import { useMessengerContext } from '../../hooks/useMessengerContext';
// import SwipeableViews from 'react-swipeable-views';
// import { useAuthContext } from '../../hooks/useAuthContext';
// import { useFetchProfile } from '../../hooks/useGetProfile';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';

// const ChatProfile = ({ onBackToChatBoxForCSS }) => {
//     const { state } = useMessengerContext(); 
//     const { otherUserDisplay, community, currentConversation } = state;
//     const { user } = useAuthContext();

//     const { profile, isLoading } = useFetchProfile(otherUserDisplay?.userId, otherUserDisplay?.communityId);

//     const [currentIndex, setCurrentIndex] = useState(0);

//     if (currentConversation && !currentConversation.members.includes(currentConversation.communityId)) {
//       if (isLoading || !profile || !otherUserDisplay?.userId || !otherUserDisplay?.communityId) {
//             return <div>Loading profile...</div>;
//         }
//     } else {
//         if (!community) {
//             return <div>Loading profile...</div>;
//         }
//     }

//     if (currentConversation.members.includes(currentConversation.communityId)) {
//         return (
//             <div className="profile-container">
//                 <div className="icon-container">
//                 <button onClick={onBackToChatBoxForCSS} className="icon back-to-chat-menu-btn hide-on-desktop">&#8678;</button>                </div>
//                 <SwipeableViews enableMouseEvents index={currentIndex} onChangeIndex={setCurrentIndex}>
//                     {community?.pics.map((pic, index) => (
//                         <div key={index} className="profile-image-container">
//                             <img src={pic} alt={`Profile ${index + 1}`} className="profile-image" />
//                             <div onClick={() => setCurrentIndex(currentIndex > 0 ? currentIndex - 1 : 0)} className="icon arrow-left">&lt;</div>
//                             <div onClick={() => setCurrentIndex(currentIndex < community.pics.length - 1 ? currentIndex + 1 : currentIndex)} className="icon arrow-right">&gt;</div>
//                         </div>
//                     ))}
//                 </SwipeableViews>
//                 <div className="user-info">
//                     <h2>{community?.title}</h2>
//                     <p id="user-bio">Hi I'm your {community?.title} bot.  I'll help find and introduce you to people in your community. </p>
//                 </div>
//             </div>
//         );
//     } else {
//         return (
//             <div className="profile-container">
//                 <div className="icon-container">
//                 <button onClick={onBackToChatBoxForCSS} className="icon back-to-chat-menu-btn hide-on-desktop">&#8678;</button>
                
//                 </div>
//                 <SwipeableViews enableMouseEvents index={currentIndex} onChangeIndex={setCurrentIndex}>
//                 {profile.pics.map((pic, index) => (
//                     <div key={index} className="profile-image-container">
//                         <img src={encodeURI(pic)} alt={`Profile ${index + 1}`} className="profile-image" />
//                         <div onClick={() => setCurrentIndex(currentIndex > 0 ? currentIndex - 1 : 0)} className="icon arrow-left">&lt;</div>
//                         <div onClick={() => setCurrentIndex(currentIndex < profile.pics.length - 1 ? currentIndex + 1 : currentIndex)} className="icon arrow-right">&gt;</div>
//                     </div>
//                 ))}
//                 </SwipeableViews>
//                 <div className="user-info">
//                     <h2>{profile.name}, {profile.age}</h2>
//                 </div>
//                 <div className="user-profile">
//                     <p id="user-bio">{profile.bio}</p>
//                 </div>
//             </div>
//         );
//     }
// };

// export default ChatProfile;


// import React, { useState, useEffect } from 'react';
// import "./ChatProfile.css";
// import { useMessengerContext } from '../../hooks/useMessengerContext';
// import SwipeableViews from 'react-swipeable-views';
// import { useAuthContext } from '../../hooks/useAuthContext';
// import { useFetchProfile } from '../../hooks/useGetProfile';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';

// const ChatProfile = ({ onBackToChatBoxForCSS }) => {
//     const { state } = useMessengerContext();
//     const { otherUserDisplay, community } = state;
//     const { user } = useAuthContext();

//     const { profile, isLoading } = useFetchProfile(otherUserDisplay?.userId, otherUserDisplay?.communityId);

//     const [currentIndex, setCurrentIndex] = useState(0);

//     if (isLoading || !profile || !otherUserDisplay?.userId || !otherUserDisplay?.communityId) {
//         return <div>Loading profile...</div>;
//     }

//     return (
//       <div className="profile-container">
//         <div className="icon-container">
//           <button onClick={onBackToChatBoxForCSS} className="icon back-to-chat-menu-btn">&#8678;</button>
//         </div>
//         <SwipeableViews enableMouseEvents index={currentIndex} onChangeIndex={setCurrentIndex}>
//           {profile.pics.map((pic, index) => (
//             <div key={index} className="profile-image-container">
//               <img src={pic} alt={`Profile ${index + 1}`} className="profile-image" />
//               <div onClick={() => setCurrentIndex(currentIndex > 0 ? currentIndex - 1 : 0)} className="icon arrow-left">&lt;</div>
//               <div onClick={() => setCurrentIndex(currentIndex < profile.pics.length - 1 ? currentIndex + 1 : currentIndex)} className="icon arrow-right">&gt;</div>
//             </div>
//           ))}
//         </SwipeableViews>
//         <div className="user-info">
//           <h2>{profile.name}, {profile.age}</h2>
//         </div>
//         <div className="user-profile">
//           <p id="user-bio">{profile.bio}</p>
//         </div>
//       </div>
//     );
// };

// export default ChatProfile;

// import React, { useEffect } from 'react';
// import "./ChatProfile.css";
// import { useMessengerContext } from '../../hooks/useMessengerContext';
// import SwipeableViews from 'react-swipeable-views';
// import { useAuthContext } from '../../hooks/useAuthContext';
// import { useFetchProfile } from '../../hooks/useGetProfile';

// const ChatProfile = ({ onBackToChatBoxForCSS }) => {
//     const { state } = useMessengerContext();
//     const { otherUserDisplay, community } = state;
//     const { user } = useAuthContext();

//     // Always call useFetchProfile at the top level, regardless of whether the IDs are defined
//     const { profile, isLoading } = useFetchProfile(otherUserDisplay?.userId, otherUserDisplay?.communityId);

//     if (isLoading || !profile || !otherUserDisplay?.userId || !otherUserDisplay?.communityId) {
//         return <div>Loading profile...</div>;
//     }

//     return (
//         <div className="chat-profile">
//             {/* Button to go back to chat menu */}
//             <button onClick={onBackToChatBoxForCSS} className="back-to-chat-menu-btn">
//                 Back to Chat Menu
//             </button>
//             {/* Swipeable display for user's pictures */}
//             <SwipeableViews enableMouseEvents>
//                 {profile.pics.map((pic, index) => (
//                     <div key={index} className="profile-pic-container">
//                         <img src={pic} alt={`Profile ${index + 1}`} className="profile-pic" />
//                     </div>
//                 ))}
//             </SwipeableViews>
//             {/* User's name, age, and location */}
//             <div className="user-info">
//                 <h2>{profile.name}, {profile.age}</h2>
//                 <p>{profile.location}</p>
//             </div>
//             {/* User's profile description */}
//             <div className="user-profile">
//                 <p>{profile.bio}</p>
//             </div>
//         </div>
//     );
    
// };

// export default ChatProfile;


// import React, { useEffect } from 'react';
// import "./ChatProfile.css";
// import { useMessengerContext } from '../../hooks/useMessengerContext';
// import SwipeableViews from 'react-swipeable-views';
// import { useAuthContext } from '../../hooks/useAuthContext';
// import { useFetchProfile } from '../../hooks/useGetProfile';

// const ChatProfile = ({ onBackToChatBoxForCSS }) => {
//     const { state } = useMessengerContext();
//     const { otherUserDisplay, community } = state;
//     const { user } = useAuthContext();

//     // Always call useFetchProfile at the top level, regardless of whether the IDs are defined
//     const { profile, isLoading } = useFetchProfile(otherUserDisplay?.userId, otherUserDisplay?.communityId);

//     if (isLoading || !profile || !otherUserDisplay?.userId || !otherUserDisplay?.communityId) {
//         return <div>Loading profile...</div>;
//     }

//     return (
//         <div className="chat-profile">
//             {/* Button to go back to chat menu */}
//             <button onClick={onBackToChatBoxForCSS} className="back-to-chat-menu-btn">
//                 Back to Chat Menu
//             </button>
//             {/* Swipeable display for user's pictures */}
//             <SwipeableViews enableMouseEvents>
//                 {profile.pics.map((pic, index) => (
//                     <div key={index} className="profile-pic-container">
//                         <img src={pic} alt={`Profile ${index + 1}`} className="profile-pic" />
//                     </div>
//                 ))}
//             </SwipeableViews>
//             {/* User's name, age, and location */}
//             <div className="user-info">
//                 <h2>{profile.name}, {profile.age}</h2>
//                 <p>{profile.location}</p>
//             </div>
//             {/* User's profile description */}
//             <div className="user-profile">
//                 <p>{profile.bio}</p>
//             </div>
//         </div>
//     );
    
// };

// export default ChatProfile;

//FIRST PASS WORKS NICELY
// import React, { useEffect } from 'react';
// import "./ChatProfile.css";
// import { useMessengerContext } from '../../hooks/useMessengerContext';
// import ChatBoxHeader from './ChatBoxHeader';
// import MessengerInput from './MessengerInput';
// import SwipeableViews from 'react-swipeable-views';
// import { useAuthContext } from '../../hooks/useAuthContext';
// import { useFetchProfile } from '../../hooks/useGetProfile';

// const ChatProfile = ({ currentConversation, onBackToChatMenuForCSS }) => {
//     const { state, dispatch } = useMessengerContext();
//     const {  otherUserDisplay, community } = state;
//     const { user } = useAuthContext();

//   // Use the hook with the user ID and community ID
//   const { profile, isLoading } = useFetchProfile(otherUserDisplay.userId, otherUserDisplay.communityId); // userid, communityId

//   // Use the hook with the user ID and community ID
// //   const { profile, isLoading } = useFetchProfile('660d63c5b2933d23f0eeac4c', '65d869abb2028ba1580121bc'); // userid, communityId


//   useEffect(() => {
//     // Only log the profile if both community and user objects are not null
//     if (user && profile) {
//       console.log('profile profile:', profile);
//       console.log('community', community)
//       console.log('otherUserDisplay', otherUserDisplay)
//     }
//   }, [user, profile, community, otherUserDisplay]);

//   // Check if profile is loading or undefined to prevent rendering errors
//   if (isLoading || !profile) {
//     return <div>Loading profile...</div>;
//   }

//   return (
//     <div className="chat-profile">
//       {/* Swipeable display for user's pictures */}
//       <SwipeableViews enableMouseEvents>
//         {profile.pics.map((pic, index) => (
//           <div key={index} className="profile-pic-container">
//             <img src={pic} alt={`Profile ${index + 1}`} className="profile-pic" />
//           </div>
//         ))}
//       </SwipeableViews>
//       {/* User's name, age, and location */}
//       <div className="user-info">
//         <h2>{profile.name}, {profile.age}</h2>
//         <p>{profile.location}</p>
//       </div>
//       {/* User's profile description */}
//       <div className="user-profile">
//         <p>{profile.bio}</p>
//       </div>
//     </div>
//   );
// };

// export default ChatProfile;
